import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import { daysBetween, earliestAllowedStartDate, MAX_DATE_RANGE_DAYS, parseDate } from './item-date-rules';

export function itemDatesValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const errors: ValidationErrors = {};
    const startDate = parseDate(control.get('startDate')?.value);
    const endDate = parseDate(control.get('endDate')?.value);

    if (startDate && endDate) {
      if (endDate.isBefore(startDate)) {
        errors['endBeforeStart'] = true;
      }
      if (daysBetween(startDate, endDate) > MAX_DATE_RANGE_DAYS) {
        errors['dateRangeWidth'] = true;
      }
    }
    if (startDate && startDate.isBefore(earliestAllowedStartDate())) {
      errors['startDateBackdated'] = true;
    }

    return Object.keys(errors).length === 0 ? null : errors;
  };
}
